<script lang="ts" generics="ITEM">
    import {getLocalization} from 'src/core';
    import {states} from 'shared/constants';
    import type {PaginationData} from '../search-manager/pagination';
    import type {ComponentSize} from 'shared/ui-widgets/types';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let paginationData: PaginationData<ITEM>;
    export let loadingSize: ComponentSize = 'md';
    export let showEmptyResultsMessage = true;

    const localize = getLocalization();
</script>

<div class="kp-search-results-loading-content" aria-live="polite">
    {#if paginationData.state.distantPage === states.PROCESSING}
        <KpLoadingBlock fillAvailableSpace size={loadingSize}/>
    {/if}

    {#if paginationData.loadPageErrorMessage}
        <p role="status" class="load-error text-center text-muted text-danger">
            <IconedContent icon="exclamation" iconColor="var(--danger-red)">
                {paginationData.loadPageErrorMessage}
            </IconedContent>
        </p>
    {/if}

    {#if paginationData.state.distantPage === states.NORMAL}
        <slot/>
    {/if}

    {#if !paginationData.loadPageErrorMessage && paginationData.state.page === states.NORMAL && paginationData.items.length === 0 && showEmptyResultsMessage}
        <div role="status" class="no-items text-center text-muted">
            {localize(/* @kp-localization commons.ZadnePolozky */ 'commons.ZadnePolozky')}
        </div>
    {/if}
</div>

<style lang="less">
    .text-danger {
        color: var(--danger-red);
    }
</style>